module.exports = __webpack_public_path__ + "static/media/2-BIM土建计量GTJ.fa28c1bb.png";